import flatpickr from "flatpickr";
import "flatpickr/dist/themes/dark.css";

import moment from "moment";

// Source: https://flatpickr.js.org/

const initFlatPickr = () => {
    let timeZone = 'Melbourne';

    flatpickr(".ins_scheduled_date", {
        enableTime: true,
        minDate: "today",
        defaultMinute: 0,
        defaultHour: 12,
        dateFormat: 'Z',
        altInput: true,
        altFormat: "j M Y, h:i K"
    });

    flatpickr("#ins_scheduled_date_admin", {
        enableTime: true,
        defaultMinute: 0,
        defaultHour: 12,
        minDate: "today",
        dateFormat: 'Z',
        altInput: true,
        altFormat: "j M Y, h:i K",
        // disableMobile: true
    });
};

export { initFlatPickr };
